import { combineReducers } from 'redux'
import listReducer, { listActions } from '@app-store/slices/companySubscriptions/list'
import oneCompanySubscriptionReducer, {
    oneCompanySubscriptionActions
} from '@app-store/slices/companySubscriptions/one'

export const companySubscriptionReducers = combineReducers({
    list: listReducer,
    one: oneCompanySubscriptionReducer
})

export const companySubscriptionActions = {
    list: listActions,
    one: oneCompanySubscriptionActions
}
